import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, RouterStateSnapshot } from '@angular/router';
import { EMPTY, Observable, of } from 'rxjs';
import { AlteGrundbuchmeldungListEntry, AlteGrundbuchmeldungSearchRequest, GbAlteGrundbuchmeldungService } from '../../../core/gb-api';
import { switchMap } from 'rxjs/operators';
import { CapAlertService } from '../../../core/extension/exceptions/cap-alert.service';
import { TranslateService } from '@ngx-translate/core';

@Injectable()
export class AlteGrundbuchmeldungListResolver {
  constructor(
    private alteGrundbuchmeldungService: GbAlteGrundbuchmeldungService,
    private capAlertService: CapAlertService,
    private translate: TranslateService
  ) {}

  resolve(
    route: ActivatedRouteSnapshot,
    state: RouterStateSnapshot
  ): Observable<AlteGrundbuchmeldungListEntry[]> | Promise<AlteGrundbuchmeldungListEntry[]> | AlteGrundbuchmeldungListEntry[] {
    const request: AlteGrundbuchmeldungSearchRequest = JSON.parse(route.queryParams['request']);
    return this.alteGrundbuchmeldungService.searchAlteGrundbuchmeldung(request).pipe(
      switchMap((response) => {
        if (response.recordsFound === 0) {
          this.capAlertService.info(this.translate.instant('KeineResultateGefunden'));
          return EMPTY;
        } else {
          return of(response.results);
        }
      })
    );
  }
}
